/*
 * @Author: Teemo Ding
 * @Date: 2021-09-24 11:03:16
 * @LastEditTime: 2022-06-13 17:16:01
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLogistics/Components/Warehouse.tsx
 */
import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
import useWareHouseList from '@/src/pages/Settings/Logistics/Hooks/useWareHouseList';
import { getDeliveryMethodByWarehouse } from '@/src/request/salesChannel/setting/logistic';
import { Form, Spin } from 'antd';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

const Warehouse = ({
  salesChannelUuid,
  form,
  runGetParcelLockers,
  runGetLogisticMethod,
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { loading, warehouseList } = useWareHouseList();
  const handleSelectOnChange = (value) => {
    runGetParcelLockers(value.uuid);
    runGetLogisticMethod(value.uuid);
    getDeliveryMethodByWarehouse(value.uuid).then((data) => {
      form.setFieldsValue({
        deliveryMethods: data,
      });
    });
  };

  return (
    <Fragment>
      <Spin spinning={loading}>
        <Form.Item
          label={`${getI18n('salesChannelLogistics.index.selectWarehouse')}*`}
          name='warehouseLocation'
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('salesChannelLogistics.index.selectWarehouse'),
              ),
            },
          ]}
          labelCol={{ span: 24 }}>
          <SelectObjectAsValue
            objectAsValue
            size='large'
            onChange={handleSelectOnChange}
            getPopupContainer={(trigger) => trigger}
            valueKey='uuid'
            labelKey='locationName'
            options={warehouseList}
            disabled={disableEdit}
          />
        </Form.Item>
      </Spin>
    </Fragment>
  );
};

export default Warehouse;
